if (!customElements.get('product-list')) {
  class ProductList extends HTMLElement {
    constructor() {
      super();
      this.videoObserver = null;
      this.observedVideos = new Set();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.product-list__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      // Initialize video on scroll ALWAYS (regardless of carousel)
      this.initVideoOnScroll();

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
  // PHASE 1: ALL READS FIRST (before any DOM changes)
  const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
  const nextEl = this.section.querySelector(this.selectors.nextEl);
  const prevEl = this.section.querySelector(this.selectors.prevEl);

  const sliderOptions = {
    slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
    spaceBetween: columnGap.tablet,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    pagination: false,
    breakpoints: {
      1024: {
        slidesPerView: parseInt(this.items),
        spaceBetween: columnGap.tabletLarge
      },
      1280: {
        slidesPerView: parseInt(this.items),
        spaceBetween: columnGap.desktop
      },
    },
    loop: true,
    threshold: 2,
  };

  if (typeof this.sliderInstance !== 'object') {
    // PHASE 2: BATCH DOM WRITES with requestAnimationFrame
    requestAnimationFrame(() => {
      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);
      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      const focusableElements = FoxTheme.a11y.getFocusableElements(this);

      focusableElements.forEach((element) => {
        element.addEventListener('focusin', () => {
          const slide = element.closest('.swiper-slide');
          this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
        });
      });
    });
  }

  if (Shopify.designMode && typeof this.sliderInstance === 'object') {
    document.addEventListener('shopify:block:select', (e) => {
      if (e.detail.sectionId != this.sectionId) return;
      let { target } = e;
      const index = Number(target.dataset.index);

      this.sliderInstance.slider.slideToLoop(index);
    });
  }
}

    // initSlider() {
    //   const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

    //   const sliderOptions = {
    //     slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
    //     spaceBetween: columnGap.tablet,
    //     navigation: {
    //       nextEl: this.section.querySelector(this.selectors.nextEl),
    //       prevEl: this.section.querySelector(this.selectors.prevEl),
    //     },
    //     pagination: false,
    //     breakpoints: {
    //       1024: {
    //         slidesPerView: parseInt(this.items),
    //         spaceBetween: columnGap.tabletLarge
    //       },
    //       1280: {
    //         slidesPerView: parseInt(this.items),
    //         spaceBetween: columnGap.desktop
    //       },
    //     },
    //     loop: true,
    //     threshold: 2,
    //   };

    //   if (typeof this.sliderInstance !== 'object') {
    //     this.classList.add(this.classes.swiper);
    //     this.sliderWrapper.classList.remove(this.classes.grid);
    //     this.sliderWrapper.classList.add(this.classes.swiperWrapper);
    //     this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
    //     this.sliderInstance.init();

    //     const focusableElements = FoxTheme.a11y.getFocusableElements(this);

    //     focusableElements.forEach((element) => {
    //       element.addEventListener('focusin', () => {
    //         const slide = element.closest('.swiper-slide');
    //         this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
    //       });
    //     });
    //   }

    //   if (Shopify.designMode && typeof this.sliderInstance === 'object') {
    //     document.addEventListener('shopify:block:select', (e) => {
    //       if (e.detail.sectionId != this.sectionId) return;
    //       let { target } = e;
    //       const index = Number(target.dataset.index);

    //       this.sliderInstance.slider.slideToLoop(index);
    //     });
    //   }
    // }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

    /**
     * Initialize Intersection Observer for scroll-triggered video playback
     * Handles Shopify-hosted videos, YouTube, and Vimeo
     */
    initVideoOnScroll() {
      // Find all video cards with play-on-scroll enabled
      const videoCards = this.querySelectorAll('.custom-video-card[data-play-on-scroll="true"]');
      
    //   console.log('[Product List Video] Found video cards with play-on-scroll:', videoCards.length);
      
      if (videoCards.length === 0) return;

      // Check browser support
      if (!('IntersectionObserver' in window)) {
        // console.warn('[Product List Video] Intersection Observer not supported');
        return;
      }

      // Create Intersection Observer with optimized settings
      const observerOptions = {
        root: null, // Use viewport as root
        rootMargin: '0px', // No margin
        threshold: 0.3 // Trigger when 30% of video is visible (more reliable than 50%)
      };

      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const videoCard = entry.target;
            
            // Check if already played
            if (this.observedVideos.has(videoCard)) {
              return;
            }
            
            // console.log('[Product List Video] Video scrolled into view');
            
            // Check if autoplay is enabled (required for play-on-scroll)
            const videoAutoplay = videoCard.dataset.videoAutoplay === 'true';
            
            if (!videoAutoplay) {
            //   console.warn('[Product List Video] Autoplay must be enabled for play-on-scroll to work');
              return;
            }
            
            // Mark as played
            this.observedVideos.add(videoCard);
            
            // Try to play the video
            this.playVideoCard(videoCard);
            
            // Stop observing this video
            this.videoObserver.unobserve(videoCard);
          }
        });
      }, observerOptions);

      // Observe all video cards
      videoCards.forEach(card => {
        this.videoObserver.observe(card);
      });
      
    //   console.log('[Product List Video] Intersection Observer initialized');
    }

    /**
     * Play video with proper handling for different video types
     * @param {HTMLElement} videoCard - The video card container
     */
    async playVideoCard(videoCard) {
      // Find the video-element wrapper (theme component)
      const videoElement = videoCard.querySelector('video-element');
      
      if (!videoElement) {
        // console.warn('[Product List Video] No video-element found');
        return;
      }

      // Wait for video-element to load if not already loaded
      if (!videoElement.hasAttribute('loaded')) {
        // console.log('[Product List Video] Waiting for video-element to load...');
        
        // Trigger the video-element to load by simulating what would happen on autoplay
        try {
          // The video-element initializes on first access to .player
          await videoElement.player.play();
        //   console.log('[Product List Video] Video started via video-element player');
          return;
        } catch (err) {
        //   console.warn('[Product List Video] Failed to play via video-element:', err);
        }
      }

      // If video-element is loaded, find the actual video/iframe
      const video = videoCard.querySelector('video');
      const iframe = videoCard.querySelector('iframe');
      
      if (video) {
        // HTML5 Video (Shopify-hosted)
        this.playHTML5Video(video);
      } else if (iframe) {
        // YouTube or Vimeo
        this.playIframeVideo(iframe);
      } else {
        // console.warn('[Product List Video] No video or iframe found in card');
      }
    }

    /**
     * Play HTML5 video element
     * @param {HTMLVideoElement} video - The video element
     */
    playHTML5Video(video) {
    //   console.log('[Product List Video] Playing HTML5 video');
      
      // Ensure video is muted (required for autoplay)
      video.muted = true;
      
      // Try to play
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // console.log('[Product List Video] ✅ HTML5 video playing successfully');
          })
          .catch(err => {
            // console.error('[Product List Video] ❌ Autoplay prevented:', err.name, err.message);
            
            // Show play button if autoplay is blocked
            const videoElement = video.closest('video-element');
            if (videoElement) {
              const poster = videoElement.querySelector('[id^="DeferredPoster-"]');
              if (poster) {
                poster.style.display = 'flex';
              }
            }
          });
      }
    }

    /**
     * Play iframe video (YouTube or Vimeo) using postMessage API
     * @param {HTMLIFrameElement} iframe - The iframe element
     */
    playIframeVideo(iframe) {
      const src = iframe.src;
      
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        // console.log('[Product List Video] Playing YouTube video');
        iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      } else if (src.includes('vimeo.com')) {
        // console.log('[Product List Video] Playing Vimeo video');
        iframe.contentWindow.postMessage('{"method":"play"}', '*');
      } else {
        // console.warn('[Product List Video] Unknown iframe video source:', src);
      }
    }

    disconnectedCallback() {
      // Clean up observer when component is removed
      if (this.videoObserver) {
        this.videoObserver.disconnect();
      }
      this.observedVideos.clear();
    }
  }
  customElements.define('product-list', ProductList);
}
